module.exports = __webpack_public_path__ + "img/add-departure-arrange-table-icon.d3a3e82f.svg";